import { ArrowLeftRight, FileText } from 'lucide-react';
import Squares2X2Icon from '@/components/icons/Squares2X2Icon';
import QuestionMarkCircleIcon from '@/components/icons/QuestionMarkCircleIcon';
import SparklesIcon from '@/components/icons/SparklesIcon';
import { EProjectStatus } from '@/enums';
import { ProjectTabsProps } from '@/types';
import Tab from './ProjectTab';

// Tabs that require a stable, finalised analysis. Compare reads
// overall_pages for two filters and generates narrative output —
// both assume the underlying data isn't still changing. Research
// Assistant runs an agentic loop over analysis artifacts that
// would be misleading on a project still collecting responses.
// Both are hidden until the project is COMPLETED.
const COMPLETED_ONLY_TABS = new Set(['compare_tab', 'ai_search_tab']);

const ALL_TABS = [
  { value: 'overview_tab', icon: Squares2X2Icon, label: 'msg.overview' },
  { value: 'questions_tab', icon: QuestionMarkCircleIcon, label: 'msg.questions' },
  { value: 'transcripts_tab', icon: FileText, label: 'msg.transcripts' },
  { value: 'compare_tab', icon: ArrowLeftRight, label: 'msg.compare' },
  // The Research Assistant is still in Beta — small "Beta" badge is
  // rendered inside Tab (at lg+ where the label is visible) so users
  // know the feature may change. Mirrored by the in-page badge in
  // ChatThread's context bar for the icon-only / narrow-width case.
  { value: 'ai_search_tab', icon: SparklesIcon, label: 'msg.researchAssistant', beta: true },
];

function ProjectTabs({ lang, currentTheme, activeTab, projectStatus }: ProjectTabsProps) {
  const isCompleted = projectStatus === EProjectStatus.COMPLETED;
  const tabs = ALL_TABS.filter((t) => !COMPLETED_ONLY_TABS.has(t.value) || isCompleted);
  return (
    <>
      {tabs.map(({ value, icon, label, beta }) => (
        <Tab
          key={value}
          value={value}
          icon={icon}
          label={lang.get(label)}
          currentTheme={currentTheme}
          activeTab={activeTab}
          beta={beta}
        />
      ))}
    </>
  );
}

export default ProjectTabs;
